// @flow
import * as React from 'react';
import { bind } from '@ta/common.api';
import { Load, Loadable } from '@ta/common.imports';

const t4bNavLoadable = new Loadable(() => import('t4b.t4b-header'));
const t4bNavMobileLoadable = new Loadable(() => import('t4b.t4b-header-mw'));

export const t4bNavPages = [
  'Owners',
  'BrandOwners',
  'ManageShopping',
  'HotelsManagementCenter',
  'HotelsManageListing',
  'TripConnectPaymentForm',
  'PaymentMethodManagement',
  'PayNow',
  'OwnerVerification',
  'FavoriteReviewManagement',
  'ViewAchAuthorization',
  'PremiumEdit',
  'SafetyManagementCenter',
  'RSOfflineBilling',
  'Starter_Packages',
];

type Props = {|
  isT4BNavPage: boolean,
  isMobileViewport: boolean,
  isMobileNav: boolean,
|};

/**
 * A wrapper around t4b.t4b-header and t4b.t4b-header-mw. This loads the mobile or desktop T4B nav
 * component when a management center page is loaded.
 */
const T4BNav = ({ isT4BNavPage, isMobileNav, isMobileViewport }: Props) => {
  if (isT4BNavPage && isMobileNav === isMobileViewport) {
    return (
      <Load component={isMobileNav ? t4bNavMobileLoadable : t4bNavLoadable}>
        {({ Component }) => Component != null && <Component black />}
      </Load>
    );
  }

  return null;
};

T4BNav.defaultProps = {
  isMobileNav: false,
};

const mapStateToProps = ({ meta, route }) => ({
  isT4BNavPage: t4bNavPages.includes(route.page),
  isMobileViewport: meta.device.viewportCategory !== 'DESKTOP',
});

export default bind<Props, {||}, _, _, _, _>((initialState, stage) => {
  const { isT4BNavPage, isMobileViewport } = mapStateToProps(initialState);

  if (isT4BNavPage) {
    if (isMobileViewport) {
      t4bNavMobileLoadable.stage(initialState, stage);
    } else {
      t4bNavLoadable.stage(initialState, stage);
    }
  }

  return mapStateToProps;
})(T4BNav);
